import { showFlashNotification } from '@clickbar/tailwindui-vue'

interface FlashValidationData {
  type: 'flash' | 'error'
  message: string
}

export function useCatchFlashValidationExceptions() {
  router.on('invalid', (event) => {
    if (event.detail.response.status === 422) {
      event.preventDefault()
      const data = event.detail.response.data as FlashValidationData
      if (data.type === 'flash') {
        showFlashNotification('error', data.message, undefined, 3000)
      }
    }
  })
}
